import UserService from 'Services/user';
import PasswordValidator from 'Components/password-validator'

export default {
	name: 'account-password-modal',
	components: {
		PasswordValidator
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
		this.mounted = true;
	},
	data() {
		return {
			isSaving: false,
			backed: false,
			mounted: false,
			showCurrentPassword: false,
			showPassword: false,
			newPassword: '',
			credential: {
				currentPassword: '',
				newPassword: ''
			}
		};
	},
	computed: {
		touched() {
			if (this.fields.password) {
				return this.fields.password.touched;
			}
			return false;
		},
		isButtonDisabled() {
			return this.isSaving || !this.mounted || !this.$refs.passwordValidator.isValid();
		}
	},
	methods: {
		changePassword() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isSaving = true;
					UserService.changePassword(this.credential.currentPassword, this.credential.newPassword)
						.then(response => {
							this.back();
						})
						.catch(error => {
							this.errors.add({
								field: 'apierror',
								msg: 'Invalid password'
							});
						})
						.finally(() => {
							this.isSaving = false;
						});
				}
			});
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/account');
			}
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/account-password-modal/script.js